import { defineStore } from 'pinia';

export type INotificationType = 'success' | 'info' | 'warning' | 'danger';

export interface INotificationOptions {
    message: string;
    type?: INotificationType;
    timeout?: number;
}

export interface INotification extends INotificationOptions {
    id: string;
    timestamp: Date;
}

export interface INotificationSettings {
    overlap: boolean;
    verticalAlign: 'top' | 'bottom';
    horizontalAlign: 'left' | 'center' | 'right';
    type: INotificationType;
    timeout: number;
    closeOnClick: boolean;
    showClose: boolean;
}

export const useNotificationStore = defineStore('notification', {
    state: () => ({
        notificationsValues: [] as INotification[], // Убедитесь, что notifications инициализирован как массив
        settings: {
            overlap: false,
            verticalAlign: 'top',
            horizontalAlign: 'right',
            type: 'info',
            timeout: 500000,
            closeOnClick: true,
            showClose: true,
        } as INotificationSettings,
    }),
    actions: {
        setOptions(options: Partial<INotificationSettings>) {
            Object.assign(this.settings, options);
        },
        addNotification(notification: INotificationOptions) {
            const id = `${Date.now()}-${Math.random()}`;
            const timestamp = new Date();

            this.notificationsValues?.push({
                id,
                message: notification.message || '',
                type: notification.type || this.settings.type,
                timeout: notification.timeout ?? this.settings.timeout,
                timestamp,
            });

            if (notification.timeout !== 0) {
                setTimeout(() => {
                    this.removeNotification(id);
                }, notification.timeout ?? this.settings.timeout);
            }
        },
        removeNotification(id: string) {
            this.notificationsValues = this.notificationsValues.filter((n) => n.id !== id);
        },
        notify(notification: INotificationOptions | INotificationOptions[]) {
            if (Array.isArray(notification)) {
                notification.forEach((n) => this.addNotification(n));
            } else {
                this.addNotification(notification);
            }
        },
    },
    getters: {
        notifications: (state) => state.notificationsValues,
    },
});
